import Header from "../../components/Header/Header";
import { Observer, observer } from "mobx-react";
import PopupMenu from "../../components/PopupMenu/PopupMenu";
//import { ReactComponent as DownArrow } from "../../assets/images/svg/downarrow.svg";
import search_svg from "../../assets/images/svg/search.svg";
import closeInput from "../../assets/images/svg/closeInput.svg";
import { useEffect, useRef, useState } from "react";
import RadioGroup from "../../components/Reports/RadioGroup";
import GoldenDropDown from "../../components/Reports/GoldenDropDown";
import ApplyFilter from "../../components/Reports/ApplyFilter";
import unsortedIcon from "../../assets/images/png/upDown.png";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import {
  CorporateTranTypeRadioBtnsData,
  exportDataMenu,
  oneDayDif,
  RECENT_CORPORATE_ACTIONS,
  REPORTS_PAGE,
  timePeriodRadioBtnsData,
  UPCOMING_CORPORATE_ACTIONS,
} from "../../utils/constants";
import Table from "../../components/Table2";
import Tabs from "../../components/Tabs";
import EmptyDerivatives from "../../components/EmptyDerivaties/EmptyDerivaties";
import emptyIcon from "../../assets/images/svg/empty.svg";
import {
  commaSeperated,
  commaSeperated2,
  convertDateToObj,
  displayUnit,
  downloadPDFFile,
  exportExcel,
  getAsOfDate,
  getCurrentDate,
  getDateString,
  getDecodedToken,
  getDisplayDate,
  getExcelDate,
  getExcelDate2,
  getExcelNumData2,
  getExcelPdfName2,
  getPrintDate,
  logEvents,
  padNumber,
  // printDocument,
  trackEventWithScreen,
} from "../../utils/functions";
import ModalFamilyWithCheckboxes from "../../components/ModalFamily/ModalFamilyWithCheckboxes";
//import PdfTable from "../../components/PdfTable/PdfTable";
import DatePicker2 from "../../components/Reports/DatePicker2";
import { useNavigate } from "react-router";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import ReportsStore from "../../store/ReportsStore";
import { setCookie, getCookie } from "../../utils/cookie";
import OverflowingText from "../../components/OverflowingText/OverflowingText";
import { useCallback } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import ExportReportList from "../../components/AccessibleDropdown/ExportReportList";
import AssetClassesCheckBox from "../../components/Reports/AssetClassesCheckBox";
const TransactionsCorporateActionReport = observer(() => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchSuggetions, setSearchSuggetions] = useState([]);
  const [selectedSuggetion, setSelectedSuggetion] = useState(null);
  const [searchSuggetionOpen, setSearchSuggetionOpen] = useState("");
  const [timePeriod, setTimePeriod] = useState(
    UserStore.transectionCorporateActionReportFilter.timePeriod,
  );
  const [tranType, setTranType] = useState(
    UserStore.transectionCorporateActionReportFilter.transectionType,
  );
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(
    UserStore.transectionCorporateActionReportFilter.selectedMember,
  );
  const [allMembersMenuOpen, setAllMembersMenuOpen] = useState(false);
  const [selectedAssetClass, setSelectedAssetClass] = useState(
    UserStore.transectionCorporateActionReportFilter.selectedAssetClass,
  );
  //  const [allAssetClassMenuOpen, setAllAssetClassMenuOpen] = useState(false);
  // const [niftyMenu, setNiftyMenu] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [initialFromDate, setInitialFromDate] = useState(null);
  const [initialToDate, setInitialToDate] = useState(null);
  const [
    upcomingtransectionCorporateTableData,
    setUpcomingtransectionCorporateTableData,
  ] = useState(ReportsStore.upcomingtransectionCorporateTableData);
  const [filteredColumn, setFilteredColumn] = useState("exDate");
  const [filteredColumnForUpcoming, setFilteredColumnForUpcoming] =
    useState("exDate");
  const [isAscendingForHeaderForUpcoming, setIsAscendingForHeaderForUpcoming] =
    useState(true);
  const [isAscendingForHeader, setIsAscendingForHeader] = useState(false);
  const [vertualRows, setVertualRows] = useState([]);

  const [isSort, setSort] = useState("asc");
  const [resetedFromDate, setResetedFromDate] = useState(null);
  const [resetedToDate, setResetedToDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  const exportTransacRef = useRef(null);
  const exportItemRefs = useRef([]);

  const reportFilter = UserStore.transectionCorporateActionReportFilter;
  const upcomingTableData = ReportsStore.upcomingtransectionCorporateTableData;
  const trasactionTableData = ReportsStore.transectionCorporateTableData;
  const selectedTabs = ReportsStore.selectedTabForTransactionCorporate;

  const ref = useRef(null);
  const onClickOutside = useCallback((menu) => {
    switch (menu) {
      case "export":
        //setNiftyMenu(false);
        break;
      case "suggesion":
        setSearchSuggetionOpen(false);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside("suggesion");
      }
      if (
        exportTransacRef.current &&
        !exportTransacRef.current.contains(event.target)
      ) {
        onClickOutside && onClickOutside("export");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      setTimeout(() => {
        document.removeEventListener("click", handleClickOutside, true);
      }, 10);
    };
  }, [onClickOutside]);

  const handleSortForTransaction = (filterType) => {
    setFilteredColumn(filterType);
    setIsAscendingForHeader(!isAscendingForHeader);
  };

  const handleTimePeriodChange = (selectedTimePeriod) => {
    setTimePeriod(selectedTimePeriod);
  };
  const handleTranTypeChange = (selectedTranType) => {
    setTranType(selectedTranType);
  };

  useEffect(() => {
    setTimePeriod(UserStore.transectionCorporateActionReportFilter.timePeriod);
  }, [
    reportFilter?.timePeriod,
    //  UserStore.transectionCorporateActionReportFilter.timePeriod
  ]);

  useEffect(() => {
    setTranType(
      UserStore.transectionCorporateActionReportFilter.transectionType,
    );
  }, [
    reportFilter?.transectionType,
    //  UserStore.transectionCorporateActionReportFilter.transectionType
  ]);

  useEffect(() => {
    setSelectedMember(
      UserStore.transectionCorporateActionReportFilter.selectedMember,
    );
  }, [
    reportFilter?.selectedMember,
    //  UserStore.transectionCorporateActionReportFilter.selectedMember
  ]);

  useEffect(() => {
    setSelectedAssetClass(
      UserStore.transectionCorporateActionReportFilter.selectedAssetClass,
    );
  }, [
    reportFilter?.selectedAssetClass,
    //  UserStore.transectionCorporateActionReportFilter.selectedAssetClass
  ]);

  useEffect(() => {
    setUpcomingtransectionCorporateTableData(
      ReportsStore.upcomingtransectionCorporateTableData,
    );
  }, [
    upcomingTableData,
    //  ReportsStore.upcomingtransectionCorporateTableData
  ]);

  useEffect(() => {
    setVertualRows((prev) =>
      ReportsStore.transectionCorporateTableData?.slice(0, 100),
    );
  }, [
    trasactionTableData,
    //ReportsStore.transectionCorporateTableData
  ]);

  useEffect(() => {
    setTranType(
      UserStore.transectionCorporateActionReportFilter.transectionType,
    );
    setSelectedAssetClass(
      UserStore.transectionCorporateActionReportFilter.selectedAssetClass,
    );
    setSelectedMember(
      UserStore.transectionCorporateActionReportFilter.selectedMember,
    );
    setTimePeriod(UserStore.transectionCorporateActionReportFilter.timePeriod);
  }, [
    reportFilter,
    //UserStore.transectionCorporateActionReportFilter
  ]);

  const getFromAndToDate = (timePeriod = "current_fy") => {
    let fDate = undefined;
    let tDate = undefined;
    let as_of_date = getAsOfDate(UserStore.asOfDate);
    if (!as_of_date) as_of_date = getCookie("asOfDate");
    const dateObjofAsOfDate = new Date(as_of_date);
    let newFromdate;
    let formattedFromdate;
    let newTodate;
    let formattedTodate;

    if (!resetedFromDate && !resetedToDate) {
      newFromdate = new Date(
        dateObjofAsOfDate.getFullYear(),
        dateObjofAsOfDate.getMonth(),
        1,
      );
      formattedFromdate =
        newFromdate?.getFullYear() +
        "-" +
        padNumber(newFromdate?.getMonth() + 1) +
        "-" +
        padNumber(newFromdate?.getDate());

      setResetedFromDate(convertDateToObj(formattedFromdate));
      setResetedToDate(convertDateToObj(as_of_date));
    }

    const currentQuarter = Math.floor(dateObjofAsOfDate.getMonth() / 3);
    const quarterStartDate = new Date(
      dateObjofAsOfDate.getFullYear(),
      currentQuarter * 3,
    );

    switch (timePeriod) {
      case "current_month":
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth(),
          1,
        );
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());

        fDate = convertDateToObj(formattedFromdate);
        tDate = convertDateToObj(as_of_date);
        break;
      case "previous_month":
        newFromdate = new Date(
          dateObjofAsOfDate.getFullYear(),
          dateObjofAsOfDate.getMonth() - 1,
          1,
        );
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        let dummyDateObj = new Date(as_of_date);
        let dummyTime = dummyDateObj?.setDate(1);
        newTodate = new Date(dummyTime - oneDayDif);
        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());

        fDate = convertDateToObj(formattedFromdate);
        tDate = convertDateToObj(formattedTodate);
        break;
      case "current_fy":
        newFromdate = new Date(
          `${
            dateObjofAsOfDate.getMonth() - 3 < 0
              ? dateObjofAsOfDate.getFullYear() - 1
              : dateObjofAsOfDate.getFullYear()
          }`,
          3,
        );

        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());

        fDate = convertDateToObj(formattedFromdate);
        tDate = convertDateToObj(as_of_date);
        break;
      case "previous_fy":
        newFromdate = new Date(
          `${
            dateObjofAsOfDate.getMonth() - 3 < 0
              ? dateObjofAsOfDate.getFullYear() - 2
              : dateObjofAsOfDate.getFullYear() - 1
          }`,
          3,
          1,
        );

        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        newTodate = new Date(
          `${
            dateObjofAsOfDate.getMonth() - 3 < 0
              ? dateObjofAsOfDate.getFullYear() - 1
              : dateObjofAsOfDate.getFullYear()
          }`,
          2,
          31,
        );

        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());
        fDate = convertDateToObj(formattedFromdate);
        tDate = convertDateToObj(formattedTodate);
        break;
      case "current_quarter":
        newFromdate = quarterStartDate;
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        fDate = convertDateToObj(formattedFromdate);
        tDate = convertDateToObj(as_of_date);
        break;
      case "previous_quarter":
        const currentQuarterStartDate = quarterStartDate;
        const currentQuarterEndDate = new Date(
          quarterStartDate.getFullYear(),
          quarterStartDate.getMonth() + 2,
          0,
        );
        const previousQuarterStartDate = new Date(
          currentQuarterStartDate.getFullYear(),
          currentQuarterStartDate.getMonth() - 3,
        );
        const previousQuarterEndDate = new Date(
          currentQuarterEndDate.getFullYear(),
          currentQuarterEndDate.getMonth() - 1,
          0,
        );
        newFromdate = previousQuarterStartDate;
        formattedFromdate =
          newFromdate?.getFullYear() +
          "-" +
          padNumber(newFromdate?.getMonth() + 1) +
          "-" +
          padNumber(newFromdate?.getDate());
        newTodate = previousQuarterEndDate;
        formattedTodate =
          newTodate?.getFullYear() +
          "-" +
          padNumber(newTodate?.getMonth() + 1) +
          "-" +
          padNumber(newTodate?.getDate());
        fDate = convertDateToObj(formattedFromdate);
        tDate = convertDateToObj(formattedTodate);

        break;

      default:
        break;
    }
    return { fromDate: fDate, toDate: tDate };
  };

  useEffect(() => {
    if (UserStore.isHydrated)
      if (timePeriod !== "custom") {
        const dates = getFromAndToDate(timePeriod);
        setFromDate(dates.fromDate);
        setToDate(dates.toDate);
      }
    // eslint-disable-next-line
  }, [timePeriod, UserStore.isHydrated]);

  useEffect(() => {
    if (datePickerModalOpen) {
      setInitialFromDate(fromDate);
      setInitialToDate(toDate);
    }
    // eslint-disable-next-line
  }, [datePickerModalOpen]);

  const recentTransactionCorporateId = "recentTransactionCorporateId";

  // // const ExtractDataContent = () => {
  // //   const exportExcelClick = () => {
  // //     exportExcel({
  // //       isFamilyOnly: true,
  // //       dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
  // //       sheetname: "Corporate Actions",
  // //       // customNameWithTime: getExcelPdfName2(
  // //       //   "",
  // //       //   UserStore.transectionCorporateActionReportFilter.selectedMember
  // //       // ),
  // //       columns: ExcelPdfClm({ isPdf: false }),

  //       reportDetails: {
  //         relatioshipManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "RM",
  //         )?.name,
  //         serviceManager: UserStore?.exportDetails?.find(
  //           (item) => item.role === "CXO",
  //         )?.name,
  //         date: getPrintDate(getAsOfDate(UserStore.asOfDate)),
  //         clientName:
  //           // UserStore.getData === "fam"
  //           //   ?
  //           UserStore.userData?.family_name,
  //         //   : UserStore.userData?.full_name,
  //       },
  //       excelName: `${getExcelPdfName2(
  //         "Corporate Actions Report -",
  //         UserStore.transectionCorporateActionReportFilter.selectedMember,
  //       )} - ${getCurrentDate()}`,
  //       ...getData(),
  //     });
  //   };

  //   const exportPdf = async () => {
  //     // printDocument(recentTransactionCorporateId, {
  //     //   width: 850,
  //     //   height: 850,
  //     //   name: `${getExcelPdfName2(
  //     //     "Corporate Actions Report -",
  //     //     UserStore.transectionCorporateActionReportFilter.selectedMember
  //     //   )}`,
  //     // });

  //     if (isDownloading) return; // guard against double-click while already running
  //     setIsDownloading(true);
  //     try {
  //       await downloadPDFFile({
  //         headerName: "Corporate Actions",
  //         fileId: recentTransactionCorporateId,
  //         isFamilyOnly: true,
  //         dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
  //         familyOrClientName: UserStore.userData?.family_name,
  //         name: `${getExcelPdfName2(
  //           "Corporate Actions Report -",
  //           UserStore.transectionCorporateActionReportFilter.selectedMember,
  //         )}`,
  //         columns: ExcelPdfClm({ isPdf: true }),
  //         data:
  //           (ReportsStore.selectedTabForTransactionCorporate ===
  //           "recent_transaction_corporate"
  //             ? getTransectionCorporateTableDataFORPDF()
  //             : getUpcomingTransectionCorporateTableData()) || [],
  //       });
  //     } finally {
  //       setIsDownloading(false);
  //       setNiftyMenu(false);
  //     }
  //   };

  //   return (
  //     <div ref={ref} className="extract_data_container downloadPdf">
  //       <p className="export_data_text">Export Data</p>
  //       <ul className="listitem_container">
  //         <li
  //           onClick={() => {
  //             exportExcelClick();
  //             setNiftyMenu(false);
  //           }}
  //         >
  //           <div className="listitem_icon excel"></div> Export to Excel
  //         </li>
  //         <li
  //           onClick={() => {
  //             exportPdf();
  //             //setNiftyMenu(false);
  //           }}
  //         >
  //           <div className="listitem_icon pdf"></div> Export to PDF
  //         </li>
  //       </ul>
  //       {isDownloading && (
  //         <div className="popup_downloader">
  //           <img src={loaderGIF} alt="img" />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  const handleKeyPress = (e) => {
    if (e.key === "ArrowDown" && searchSuggetionOpen) {
      e.preventDefault();
      const suggetionElArr = document.getElementById(
        "transaction_suggetion_box_for_search",
      ).children;
      if (document.activeElement === document.getElementById("search-box")) {
        e.preventDefault();
        suggetionElArr[0].focus();
      }
    }
    if (e.key === "ArrowUp" && searchSuggetionOpen) {
      e.preventDefault();
      const suggetionElArr = document.getElementById(
        "transaction_suggetion_box_for_search",
      ).children;
      if (document.activeElement === document.getElementById("search-box")) {
        e.preventDefault();
        suggetionElArr[suggetionElArr?.length - 1].focus();
      }
    }
  };

  const handleKeydownForSuggetion = (e) => {
    if (e.key === "Enter") {
      e.target.click();
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextEl = document.activeElement.nextElementSibling;
      if (!nextEl) {
        const suggetionElArr = document.getElementById(
          "transaction_suggetion_box_for_search",
        ).children;
        suggetionElArr[0].focus();
        return;
      }
      nextEl.focus();
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevEl = document.activeElement.previousElementSibling;
      if (!prevEl) {
        const suggetionElArr = document.getElementById(
          "transaction_suggetion_box_for_search",
        ).children;
        suggetionElArr[suggetionElArr?.length - 1].focus();
        return;
      }
      prevEl.focus();
      return;
    }
  };

  useEffect(() => {
    if (selectedSuggetion) {
      ReportsStore.updateTransactionCorporateReportData(
        ReportsStore.transectionCorporateTableData?.filter(
          (eachTransaction) => {
            return selectedSuggetion
              ? eachTransaction?.security_name === selectedSuggetion?.title
              : true;
          },
        ),
      );
    } else {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.updateTableDataLoader(false);

      sortRecentData(ReportsStore.rememberedtransectionCorporateTableData);
      // ReportsStore.updateTransactionCorporateReportData(

      // );
    }
  }, [selectedSuggetion]);

  const SearchMenuContent = () => {
    let newArr = searchSuggetions.filter((value, index, self) => {
      return (
        self.findIndex(
          (obj) => obj.from === value.from && obj.title === value.title,
        ) === index
      );
    });

    return (
      <>
        {newArr?.length ? (
          <div
            ref={ref}
            className="suggetion_box_for_search"
            id="transaction_suggetion_box_for_search"
          >
            {newArr.map((suggetion, i) => (
              <div
                className="suggetion"
                tabIndex="0"
                key={i}
                onKeyDown={(e) => handleKeydownForSuggetion(e, i)}
                onClick={() => {
                  setSelectedSuggetion(suggetion);
                  setSearchSuggetionOpen(false);
                  setSearch(suggetion.title);
                  ReportsStore.updateTransectionCorporateReportTab(
                    suggetion.from,
                  );
                }}
              >
                {suggetion.title}
              </div>
            ))}
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const tempSuggetionArr = [];

    ReportsStore.rememberedtransectionCorporateTableData?.forEach(
      (transaction) => {
        if (
          transaction?.security_name
            ?.toLocaleLowerCase()
            ?.includes(search?.toLocaleLowerCase())
        ) {
          const obj = {
            title: transaction.security_name,
            from: "recent_transaction_corporate",
          };
          tempSuggetionArr.push(obj);
        }
      },
    );

    upcomingtransectionCorporateTableData?.forEach((transaction) => {
      if (
        transaction?.security_name
          ?.toLocaleLowerCase()
          ?.includes(search?.toLocaleLowerCase())
      ) {
        const obj = {
          title: transaction.security_name,
          from: "upcoming_transactions_corporate",
        };
        tempSuggetionArr.push(obj);
      }
    });

    if (search && tempSuggetionArr?.length) {
      setSearchSuggetions([...tempSuggetionArr]);
    } else {
      setSearchSuggetions([]);
      setSelectedSuggetion(null);
    }
    // eslint-disable-next-line
  }, [search]);

  // const AllAssetClassMenuContent = () => {
  //   const handleAssetClassChange = (changedAssetClass) => {
  //     if (changedAssetClass === "All") {
  //       if (
  //         selectedAssetClass === "All" ||
  //         ReportsStore.allAssetClassesData
  //           ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
  //           ?.every(Boolean)
  //       ) {
  //         setSelectedAssetClass([]);
  //       } else {
  //         setSelectedAssetClass(
  //           ReportsStore.allAssetClassesData?.map((assetClass) => {
  //             return assetClass?.id;
  //           }),
  //         );
  //       }
  //     } else {
  //       if (selectedAssetClass === "All") {
  //         setSelectedAssetClass(
  //           ReportsStore.allAssetClassesData
  //             ?.map((assetClass) => {
  //               return assetClass?.id;
  //             })
  //             .filter((assetClassId) => assetClassId !== changedAssetClass),
  //         );
  //       } else {
  //         if (selectedAssetClass?.includes(changedAssetClass)) {
  //           setSelectedAssetClass((prevState) => {
  //             return prevState.filter(
  //               (eachAssetClass) => eachAssetClass !== changedAssetClass,
  //             );
  //           });
  //         } else {
  //           setSelectedAssetClass([...selectedAssetClass, changedAssetClass]);
  //         }
  //       }
  //     }
  //   };
  //   return (
  //     <ul className="portfolio_report_accounts_container">
  //       <li
  //         className="account_listitem cursor"
  //         onClick={() => handleAssetClassChange("All")}
  //       >
  //         <div className="each_checkbox_wrapper">
  //           <input
  //             checked={
  //               selectedAssetClass === "All" ||
  //               ReportsStore.allAssetClassesData
  //                 ?.map((assetClass) =>
  //                   selectedAssetClass?.includes(assetClass.id),
  //                 )
  //                 ?.every(Boolean)
  //             }
  //             onChange={() => handleAssetClassChange("All")}
  //             type="checkbox"
  //             className="checkbox"
  //           />
  //           <label className="checkbox_label cursor">All Asset Classes</label>
  //         </div>
  //       </li>
  //       {ReportsStore.allAssetClassesData?.map((accountData, index) => (
  //         <li
  //           className="account_listitem cursor"
  //           onClick={() => handleAssetClassChange(accountData.id)}
  //         >
  //           <div className="each_checkbox_wrapper">
  //             <input
  //               checked={
  //                 selectedAssetClass === "All" ||
  //                 selectedAssetClass.includes(accountData.id)
  //                   ? true
  //                   : false
  //               }
  //               onChange={() => handleAssetClassChange(accountData.id)}
  //               type="checkbox"
  //               className="checkbox"
  //             />
  //             <label
  //               className="checkbox_label cursor"
  //               for={accountData.id}
  //               style={{ display: "contents" }}
  //             >
  //               <OverflowingText
  //                 text={
  //                   accountData?.name
  //                     ? `${accountData?.name
  //                         .charAt(0)
  //                         .toUpperCase()}${accountData?.name
  //                         .slice(1)
  //                         .toLowerCase()}`
  //                     : accountData?.name
  //                 }
  //                 width={140}
  //                 textClassName="radio_btn_label cursor_imp"
  //                 tooltipOnHover={true}
  //                 position="left"
  //                 tooltipClassName={
  //                   index === 0
  //                     ? "asset_class_tooltip_styles_bottom"
  //                     : "asset_class_tooltip_styles"
  //                 }
  //               />
  //             </label>
  //           </div>
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // };

  const AllMembersMenuContent = () => (
    <>
      <ul className="portfolio_report_container">
        <ModalFamilyWithCheckboxes
          setSelectedMemberForReports={(id) => {
            setSelectedMember(id);
          }}
          isSort={isSort}
          setSort={setSort}
          selectedMemberForReports={selectedMember}
          showResetAndSubmit={false}
          searchBarWidth="351px"
        />
      </ul>
    </>
  );

  const amtCellRendererForRecent = (data, _, key) => {
    if (key === "amount") {
      return (
        <p className="qty_cell font-roboto">
          <p>
            {`₹ ${commaSeperated2(data.value)}`}{" "}
            <span className="unitFont">{`${displayUnit(
              data.value_type,
            )}`}</span>
          </p>
        </p>
      );
    } else if (key === "quantity" || key === "rate") {
      return (
        <p className="qty_cell font-roboto">
          {data ? `${commaSeperated(data)}` : "-"}
        </p>
      );
    }

    return <p className="qty_cell  font-roboto">{data || "-"}</p>;
  };

  const AccountName = (data, row) => {
    return (
      <p
        style={{ fontWeight: 400, fontFamily: "Encode Sans", color: "#03002f" }}
        className="qty_cell"
      >
        {data ? (
          <OverflowingText
            text={data}
            textClassName="corporate_tooltip"
            ellipsisTextClassName=""
            position="left"
          />
        ) : (
          "-"
        )}
      </p>
    );
  };

  const DateCellRendererForRecent = (data, row) => {
    return (
      <p
        style={{ fontWeight: 400, fontFamily: "Encode Sans", color: "#03002f" }}
        className="qty_cell"
      >
        {data ? getDisplayDate(data) : "-"}
      </p>
    );
  };
  const actionCellRenderer = (data, _, key) => {
    if (key === "type") {
      return (
        <p
          style={{ fontFamily: "Encode Sans", whiteSpace: "nowrap" }}
          className="action_cell transaction_type_custom"
        >
          {data.toUpperCase() || "-"}
        </p>
      );
    }
    return <p className="action_cell">{data || "-"}</p>;
  };

  const asscCellRenderer = (data) => {
    return (
      <p className="assc_cell">
        <p
          style={{
            width: "fit-content",
            background: "",
            fontFamily: "Encode Sans",
          }}
        >
          {data || "-"}
        </p>
      </p>
    );
  };

  const asscCellRenderer2 = (data) => {
    return (
      <p className="assc_cell">
        <p
          style={{
            width: "fit-content",
            background: "#e1fff4",
            fontFamily: "Encode Sans",
          }}
        >
          {data || "-"}
        </p>
      </p>
    );
  };

  const assetCellRenderer = ({ label, key, sortable, width, classn }) => {
    return (
      <th className="asset_class_header" style={{ width: width }}>
        <div className="header_cell">
          <p>{label}</p>
          {sortable && (
            <div className="accordion_table_header_child_icon">
              <img src={unsortedIcon} alt="sort" />
            </div>
          )}
        </div>
      </th>
    );
  };

  const instrumentNameCellRenderer = (data, _, key) => {
    return (
      <>
        <OverflowingText
          width={300}
          text={data}
          ellipsisTextClassName="corporate_action_ins_name_class_report"
          position="right"
        />
      </>
    );
  };

  const allClm = [
    {
      label: "Instrument Name",
      key: "security_name",
      width: "400px",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      //width: "186px",
      cellRenderer: actionCellRenderer,
      cellRendererPdf: (data, row, key) => data.toUpperCase(),
    },
    {
      label: "Amount",
      key: "amount",
      //width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) =>
        getExcelNumData2(data?.actual_value, true, 2),
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
      cellRendererPdf: (data) => data || "-",
      customHeaderRenderer: assetCellRenderer,
      //width: "195px",
    },
    {
      label: "Date",
      key: "date",
      //width: "180px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Record Date/Issue Start Date",
      width: "170px",
      key: "issueStartDate",
      key2: "recordDate",
      sortable: true,
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Issue End Date",
      key: "issueEndDate",

      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Expiry Date",
      key: "exDate",
      //width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Issue Price",
      key: "issuePrice",
      //width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) => getExcelNumData2(data, true, 2),
    },
    {
      label: "Ratio",
      key: "ratio",
      //width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data) => data || "-",
    },
  ];

  const corporateActionsColumns = [
    {
      label: "Instrument Name",
      key: "security_name",
      width: "370px",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      width: "186px",
      cellRenderer: actionCellRenderer,
      cellRendererPdf: (data, row, key) => data.toUpperCase(),
    },
    {
      label: "Price",
      key: "rate",
      width: "146px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) => getExcelNumData2(data, true, 2),
    },
    {
      label: "Qty",
      key: "quantity",
      width: "106px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) => getExcelNumData2(data, false, 2),
    },
    {
      label: "Amount",
      key: "amount",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) => getExcelNumData2(data, true, 2),
    },
    {
      label: "Date",
      key: "date",
      width: "180px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Record Date",
      key: "date",
      width: "180px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
      cellRendererPdf: (data) => data || "-",
      customHeaderRenderer: assetCellRenderer,
      width: "195px",
    },

    {
      label: "EX Date",
      key: "exDate",
      width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
      classn: "exDateHeader",
    },

    {
      label: "Issue Start Date",
      key: "issueStartDate",
      width: "170px",
      sortable: true,
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Record Date/Issue Start Date",
      key: "issueStartDate",
      key2: "recordDate",
      width: "170px",
      sortable: true,
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Issue End Date",
      key: "issueEndDate",
      width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Record Date",
      key: "recordDate",
      width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },

    {
      label: "Expiry Date",
      key: "exDate",
      width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
    {
      label: "Issue Price",
      key: "issuePrice",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) => getExcelNumData2(data, true, 2),
    },
    {
      label: "Ratio",
      key: "ratio",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data) => data || "-",
    },
    {
      label: "Div/Share",
      key: "divPerShare",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data) => data || "-",
    },
  ];

  const dividentColumns = [
    {
      label: "Instrument Name",
      key: "security_name",
      width: "370px",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      width: "186px",
      cellRenderer: actionCellRenderer,
      cellRendererPdf: (data, row, key) => data.toUpperCase(),
    },

    {
      label: "Amount",
      key: "amount",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) =>
        getExcelNumData2(data?.actual_value, true, 2),
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
      cellRendererPdf: (data) => data || "-",
      customHeaderRenderer: assetCellRenderer,
      width: "195px",
    },
    {
      label: "Date",
      key: "exDate",
      width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
      classn: "exDateHeader",
    },
    {
      label: "Div/Share",
      key: "divPerShare",
      width: "186px",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data) => data || "-",
      justifyContent: "flex-end",
    },
  ];
  const dividentColumnsUpcoming = [
    {
      label: "Instrument Name",
      key: "security_name",

      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      cellRenderer: actionCellRenderer,
      cellRendererPdf: (data, row, key) => data.toUpperCase(),
    },

    {
      label: "Amount",
      key: "amount",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) =>
        getExcelNumData2(data?.actual_value, true, 2),
    },
    {
      label: "Record Date",
      key: "recordDate",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },

    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
      cellRendererPdf: (data) => data || "-",
      customHeaderRenderer: assetCellRenderer,
    },
    {
      label: "Ex Date",
      key: "exDate",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
      classn: "exDateHeader",
    },
    {
      label: "Div/Share",
      key: "divPerShare",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data) => data || "-",
      justifyContent: "flex-end",
    },
  ];
  const intColumnsRecent = [
    {
      label: "Instrument Name",
      key: "security_name",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      cellRenderer: actionCellRenderer,
      cellRendererPdf: (data, row, key) => data.toUpperCase(),
    },
    {
      label: "Amount",
      key: "amount",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) =>
        getExcelNumData2(data?.actual_value, true, 2),
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer2,
      cellRendererPdf: (data) => data || "-",
    },

    {
      label: "Date",
      key: "exDate",
      // width: "170px",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
      classn: "exDateHeader corporate_date_custom",
    },
    // {
    //   label: "Acc Name",
    //   key: "account_name",
    //   // width: "170px",
    //   sortable: true,
    //   cellRendererExcel: (data, row, key) => (data ? data : "-"),
    //   cellRenderer: AccountName,
    //   cellRendererPdf: (data) => (data ? data : "-"),
    //   classn: "exDateHeader corporate_date_custom",
    // },
  ];
  const intColumnsUpcoming = [
    {
      label: "Instrument Name",
      key: "security_name",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Transaction Type",
      key: "type",
      sortable: true,
      cellRenderer: actionCellRenderer,
      cellRendererPdf: (data, row, key) => data.toUpperCase(),
    },
    {
      label: "Amount",
      key: "amount",
      sortable: true,
      cellRenderer: amtCellRendererForRecent,
      cellRendererPdf: (data, row, key) =>
        getExcelNumData2(data?.actual_value, true, 2),
    },
    {
      label: "Asset Class",
      key: "asset_class",
      cellRenderer: asscCellRenderer,
      cellRendererPdf: (data) => data || "-",
      customHeaderRenderer: assetCellRenderer,
    },

    {
      label: "Estimate Date",
      key: "exDate",
      sortable: true,
      cellRendererExcel: (data, row, key) => getExcelDate2(data, "-"),
      cellRenderer: DateCellRendererForRecent,
      cellRendererPdf: (data) => (data ? getExcelDate(data) : "-"),
    },
  ];

  const columnKeysByTranType = {
    interest: [
      "Instrument Name",
      "Transaction Type",
      "Price",
      "Qty",
      "Amount",
      "Date",
      "Asset Class",
      "Expiry Date",
    ],
    dividend: [
      "Instrument Name",
      "Transaction Type",
      "Amount",
      "Record Date",
      "Asset Class",
      "EX Date",
      "Div/Share",
    ],
    cash_dividend: [
      "Instrument Name",
      "Transaction Type",
      "Record Date",
      "Expiry Date",
      "Div/Share",
    ],
    bonus: [
      "Instrument Name",
      "Transaction Type",
      "Record Date",
      "Expiry Date",
      "Ratio",
    ],
    split: [
      "Instrument Name",
      "Transaction Type",
      "Record Date",
      "Expiry Date",
      "Ratio",
    ],
    buyback: [
      "Instrument Name",
      "Transaction Type",
      "Issue Start Date",
      "Issue End Date",
      "Issue Price",
    ],
    rights_issued: [
      "Instrument Name",
      "Transaction Type",
      "Issue Start Date",
      "Issue End Date",
      "Issue Price",
      "Ratio",
    ],
    principle_payback: [
      "Instrument Name",
      "Transaction Type",
      "Price",
      "Qty",
      "Amount",
      "Date",
      "Asset Class",
      "Expiry Date",
    ],
    others: [
      "Instrument Name",
      "Transaction Type",
      "Price",
      "Qty",
      "Amount",
      "Date",
      "Asset Class",
      "Expiry Date",
    ],
    all: [
      "Instrument Name",
      "Transaction Type",
      "Amount",
      "Asset Class",
      "Date",
      "Record Date/Issue Start Date",
      "Issue End Date",
      "Expiry Date",
      "Issue Price",
      "Ratio",
    ],
    default: [
      "Instrument Name",
      "Transaction Type",
      "Amount",
      "Asset Class",
      "Date",
    ],
  };

  const getUpcomingColumns = (allColumns, isSameUI) => {
    const type =
      UserStore.transectionCorporateActionReportFilter.transectionType;
    const upColmns = {
      interest: intColumnsUpcoming,
      dividend: dividentColumnsUpcoming,
      all: [...intColumnsRecent].concat([...[pdfExtraColumn[1]]]),
    };

    if (isSameUI) return [...intColumnsRecent].concat([...[pdfExtraColumn[1]]]);
    else
      return upColmns[type]
        ? upColmns[type]
        : allColumns.filter((column) =>
            columnKeysByTranType[type].includes(column.label),
          );
  };

  const filterableColumns = {
    dividend: dividentColumns,
    interest: intColumnsRecent,
    principle_payback: intColumnsRecent,
    others: intColumnsRecent,
  };

  const filterableColumnsUpcoming = {
    interest: intColumnsUpcoming,
    dividend: dividentColumnsUpcoming,
  };

  const getDynamicColumns = ({
    allColumns,
    isSameUI,
    isNonFilterable,
    isAll,
  }) => {
    const type =
      UserStore.transectionCorporateActionReportFilter.transectionType;
    // for ui this will show same columns for all the types
    if (isSameUI) return [...intColumnsRecent].concat([...[pdfExtraColumn[1]]]);
    // this is give columns for pdf and excel
    else if (isAll) return allClm;
    else if (isNonFilterable)
      return allColumns.filter((column) =>
        columnKeysByTranType[
          UserStore.transectionCorporateActionReportFilter.transectionType
        ].includes(column.label),
      );
    else return [...filterableColumns[type]];

    // if (
    //   UserStore.transectionCorporateActionReportFilter.transectionType ===
    //   "dividend"
    // ) {
    //   return dividentColumns;
    // } else if (
    //   UserStore.transectionCorporateActionReportFilter.transectionType ===
    //     "interest" ||
    //   UserStore.transectionCorporateActionReportFilter.transectionType ===
    //     "principle_payback" ||
    //   UserStore.transectionCorporateActionReportFilter.transectionType ===
    //     "others"
    // ) {
    //   return intColumnsRecent;
    // } else {
    //   return allColumns.filter((column) =>
    //     columnKeysByTranType[
    //       UserStore.transectionCorporateActionReportFilter.transectionType
    //     ].includes(column.label)
    //   );
    // }
    // }
    // else if (
    //   ReportsStore.selectedTabForTransactionCorporate ===
    //   "upcoming_transactions_corporate"
    // ) {
    //   if (
    //     UserStore.transectionCorporateActionReportFilter.transectionType ===
    //     "interest"
    //   ) {
    //     return intColumnsUpcoming;
    //   } else if (
    //     UserStore.transectionCorporateActionReportFilter.transectionType ===
    //     "dividend"
    //   ) {
    //     return dividentColumnsUpcoming;
    //   } else {
    //     return allColumns.filter((column) =>
    //       columnKeysByTranType[
    //         UserStore.transectionCorporateActionReportFilter.transectionType
    //       ].includes(column.label)
    //     );
    //   }
    // }
  };

  const ExcelPdfClm = ({ isPdf }) => {
    const type =
      UserStore.transectionCorporateActionReportFilter.transectionType;
    const isAll = type === "all";
    const isUpcoming =
      ReportsStore.selectedTabForTransactionCorporate ===
      "upcoming_transactions_corporate";
    if (isUpcoming) {
      if (!isAll)
        return [...getUpcomingColumns(corporateActionsColumns, false)];
      else {
        const columns = [...allClm];
        columns[7].label = "Estimate Date";
        return columns;
      }
    } else {
      const isNonFilterable = isAll || !filterableColumns[type];

      let data = [
        ...getDynamicColumns({
          allColumns: corporateActionsColumns,
          isSameUI: false,
          isNonFilterable,
          isAll,
        }),
      ];
      return data.concat(pdfExtraColumn);
    }
  };

  const pdfExtraColumn = [
    {
      label: "Client Name",
      key: "client_name",
      sortable: true,
      cellRendererExcel: (data, row, key) => data,
      cellRendererPdf: (data, row, key) => data,
    },
    {
      label: "Account Name",
      key: "account_name",
      sortable: true,
      cellRendererExcel: (data, row, key) => (data ? data : "-"),
      cellRenderer: AccountName,
      cellRendererPdf: (data) => (data ? data : "-"),
      //  classn: "exDateHeader corporate_date_custom",
    },
  ];

  const getTableClass = () => {
    switch (UserStore.transectionCorporateActionReportFilter.transectionType) {
      case "interest":
        //return "interest";
        return "all";
      case "principle_payback":
        // return "interest";
        return "all";
      case "others":
        // return "interest";
        return "all";
      case "dividend":
        // return "dividend2";
        return "all";
      default:
        return "all";
    }
  };

  const getUpcomingClass = () => {
    switch (UserStore.transectionCorporateActionReportFilter.transectionType) {
      case "interest":
        return "all";
      //return "interest";
      case "dividend":
        return "all";
      //return " dividendUpcoming";
      case "all":
        return "all";
      default:
        return "all";
    }
  };

  useEffect(() => {
    UserStore.upDateData("reportsFirstState", selectedMember);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      ReportsStore.selectedTabForTransactionCorporate ===
      "recent_transaction_corporate"
    ) {
      trackEventWithScreen({
        eventName: REPORTS_PAGE,
        screenName: RECENT_CORPORATE_ACTIONS,
      });

      logEvents(REPORTS_PAGE, {
        screenName: RECENT_CORPORATE_ACTIONS,
      });
    } else {
      trackEventWithScreen({
        eventName: REPORTS_PAGE,
        screenName: UPCOMING_CORPORATE_ACTIONS,
      });
      logEvents(REPORTS_PAGE, {
        screenName: UPCOMING_CORPORATE_ACTIONS,
      });
    }
  }, [
    selectedTabs,
    //  ReportsStore.selectedTabForTransactionCorporate
  ]);

  useEffect(() => {
    if (UserStore.isHydrated) {
      const fetchData = async () => {
        // const userId = getCookie("userid");
        // setLoading(false);
        // ReportsStore.updateTableDataLoader(true);
        // window.scrollTo(0, 0);
        document.addEventListener("scroll", () => {
          if (document.documentElement.scrollTop === 0) {
            setVertualRows((prev) =>
              ReportsStore.transectionCorporateTableData?.slice(0, 100),
            );
          }
          if (
            document.documentElement.scrollHeight -
              document.documentElement.scrollTop +
              document.documentElement.clientHeight <
              2000 &&
            ReportsStore.transectionCorporateTableData?.length
          ) {
            // if (vertualRows?.length > 0) {
            setVertualRows((prev) => {
              if (prev) {
                return [
                  ...prev,
                  ...ReportsStore.transectionCorporateTableData.slice(
                    prev?.length,
                    prev?.length + 100,
                  ),
                ];
              }
            });
            // }
          }
        });
        AuthStore.updateLoadingFullScreen(true);

        // ReportsStore.populateReportsData();
        // ReportsStore.updateTransectionCorporateReportTab(
        //   "recent_transaction_corporate"
        // );
      };
      fetchData();

      return () => {
        setTimeout(() => {
          ReportsStore.updateTableDataLoader(true);
          //  AuthStore.updateLoadingFullScreen(true);
          const resetFilterToDefaultState = () => {
            UserStore.transectionCorporateActionReportFilter = {
              timePeriod: "current_fy",
              transectionType: "interest",
              selectedMember:
                (getDecodedToken()?.user_type === "employee" ||
                  getDecodedToken()?.user_type === "customer") &&
                UserStore.selectedClientId === "0"
                  ? "All"
                  : selectedMember !== "All"
                    ? selectedMember
                    : UserStore.transectionCorporateActionReportFilter
                        .selectedMember,
              selectedAssetClass: "All",
            };
          };
          resetFilterToDefaultState();
        }, 10);
      };
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (UserStore.isHydrated) {
      const getData = async () => {
        const userId = getCookie("userid");
        setLoading(false);
        ReportsStore.updateTableDataLoader(true);
        window.scrollTo(0, 0);
        await ReportsStore?.getprofile({ userId });
        ReportsStore.populateReportsData();
        ReportsStore.updateTransectionCorporateReportTab(
          "recent_transaction_corporate",
        );
      };
      getData();
    }
  }, [UserStore.isHydrated]);

  useEffect(() => {
    if (
      ReportsStore.allAssetClassesAPIcallstate === "success" &&
      ReportsStore.allMembersAPIcallstate === "success" &&
      UserStore.isHydrated
    ) {
      ReportsStore.updateTableDataLoader(true);
      window.scrollTo(0, 0);
      if (fromDate && toDate) {
        ReportsStore.getDataForTransectionCorporateReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
        );
      } else {
        const { fromDate, toDate } = getFromAndToDate();
        setToDate(toDate);
        setFromDate(fromDate);
        ReportsStore.getDataForTransectionCorporateReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
        );
      }
    }
    // eslint-disable-next-line
  }, [
    ReportsStore.allAssetClassesAPIcallstate,
    ReportsStore.allMembersAPIcallstate,
    UserStore.isHydrated,
  ]);

  const getHeadingForAssetClass = (selectedAssetClass) => {
    if (
      selectedAssetClass === "All" ||
      ReportsStore.allAssetClassesData
        ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
        ?.every(Boolean)
    ) {
      return "All Asset Classes";
    } else if (selectedAssetClass?.length === 0) {
      return "None selected";
    } else {
      const data = ReportsStore.allAssetClassesData
        ?.map((assetClass) =>
          selectedAssetClass.includes(assetClass?.id) ? assetClass?.name : "",
        )
        .filter((selectedAssetClass) => selectedAssetClass);
      if (data?.length === 1) {
        return data?.[0];
      }
      return data.map((obj) => obj).join(", ");
    }
  };

  const getHeadingForMembers = (selectedMember) => {
    if (
      getDecodedToken()?.user_type === "manager" ||
      (getDecodedToken()?.user_type === "employee" &&
        UserStore?.selectedClientId !== "0" &&
        !UserStore.userData?.isprimary) ||
      (getDecodedToken()?.user_type === "customer" &&
        getDecodedToken().primary === "false") ||
      (UserStore.getData !== "fam" &&
        (getDecodedToken()?.user_type === "customer" ||
          getDecodedToken()?.user_type === "employee") &&
        UserStore.currentFamilyMembers?.length === 1)
    ) {
      return UserStore?.userData?.full_name;
    } else {
      if (
        selectedMember === "0" ||
        selectedMember === "All" ||
        UserStore.currentFamilyMembers
          ?.map((familyMember) =>
            selectedMember.find(
              (member) => member?.user_id === familyMember?.user_id,
            ),
          )
          ?.every(Boolean)
      ) {
        return "All Members";
      } else if (selectedMember?.length === 0) {
        return "None selected";
      } else {
        const data = selectedMember;
        if (data?.length === 1) {
          return data[0].full_name;
        }
        return data.map((obj) => obj.full_name).join(", ");
      }
    }
  };

  const onApplyFilter = () => {
    setSearch("");
    setSelectedSuggetion(null);
    setFilteredColumn("exDate");
    setFilteredColumnForUpcoming("security_name");
    setIsAscendingForHeader(false);
    setIsAscendingForHeaderForUpcoming(false);
    if (!selectedMember?.length || !selectedAssetClass?.length) {
      ReportsStore.transectionCorporateTableData = [];
      ReportsStore.upcomingtransectionCorporateTableData = [];
    } else {
      ReportsStore.updateTableDataLoader(true);
      ReportsStore.updateTransectionCorporateActionFilter({
        timePeriod: timePeriod,
        transectionType: tranType,
        selectedMember:
          selectedMember?.length === UserStore.currentFamilyMembers?.length
            ? "All"
            : selectedMember,
        selectedAssetClass: selectedAssetClass,
      });
      if (fromDate && toDate) {
        ReportsStore.updateTableDataLoader(true);
        ReportsStore.getDataForTransectionCorporateReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
        );
      }
    }
  };
  const onClearFilter = () => {
    setSearch("");
    setSelectedSuggetion(null);
    setFilteredColumn("exDate");
    setFilteredColumnForUpcoming("security_name");
    setIsAscendingForHeader(false);
    setIsAscendingForHeaderForUpcoming(false);
    ReportsStore.updateTableDataLoader(true);
    ReportsStore.updateTransectionCorporateActionFilter({
      timePeriod: "current_fy",
      transectionType: "interest",
      selectedMember:
        getDecodedToken()?.user_type === "manager" ||
        (getDecodedToken()?.user_type === "employee" &&
          UserStore?.selectedClientId !== "0") ||
        (getDecodedToken()?.user_type === "customer" &&
          getDecodedToken()?.primary === "false") ||
        UserStore?.selectedClientId !== "0"
          ? UserStore.transectionCorporateActionReportFilter.selectedMember
          : "All",
      selectedAssetClass: "All",
    });

    const { fromDate, toDate } = getFromAndToDate("current_fy");

    if (fromDate && toDate) {
      setTimeout(() => {
        ReportsStore.updateTableDataLoader(true);
        ReportsStore.getDataForTransectionCorporateReport(
          `${fromDate?.year}-${fromDate?.month}-${fromDate?.date}`,
          `${toDate?.year}-${toDate?.month}-${toDate?.date}`,
        );
      }, 1000);
    }
  };

  const getTransectionCorporateTableData = () => {
    return vertualRows;
  };

  const getData = () => {
    const columnsReference = {
      INTEREST: "interest", //
      Dividend: "dividend", //
      "Cash dividend": "cash_dividend",
      Bonus: "bonus",
      Split: "split",
      buyback: "buyback",
      "Rights issued": "rights_issued",
      "Principal payback": "principle_payback", //
      Others: "others", //
    };
    const result = {};
    let columnObject = {};
    const isRecent =
      ReportsStore.selectedTabForTransactionCorporate ===
      "recent_transaction_corporate";
    let isAll = null;
    let Others = {
      "Demerger out": true,
      "Demerger in": true,
      Others: true,
    };

    isAll = tranType === "all";

    const setResult = (tranType, allDataArr) => {
      if (tranType === "all" && allDataArr.length) {
        // we have to create seperate sheets for individual columns
        // if transaction type is Demerger out or Demerger in or others then those transactions will come under others
        // and if tranction type name includes dividend in it then it will the part of dividend sheetname
        // else we will create seperate sheet
        // for every transaction type which is available on ui we have different columns in excel sheet
        // but if any transaction type which is new or does not follow above condition then we create new sheet for it and
        // its columns will be default columns columnKeysByTranType["default"] and in recent transaction we concat pdfExtraColumn to it

        for (let i = 0; i < allDataArr.length; i++) {
          //In case of dividend type , there may come other transaction type which we have
          // add inside dividend type sheet
          if (allDataArr[i].type?.toLocaleLowerCase()?.includes("dividend")) {
            if (!result[["Dividend"]])
              result["Dividend"] = [{ ...allDataArr[i] }];
            else result["Dividend"].push(allDataArr[i]);
          } else {
            if (!result[allDataArr[i].type] && !Others[allDataArr[i].type])
              result[allDataArr[i].type] = [{ ...allDataArr[i] }];
            else if (Others[allDataArr[i].type] && !result.Others)
              result["Others"] = [{ ...allDataArr[i] }];
            else if (!Others[allDataArr[i].type])
              result[allDataArr[i].type].push(allDataArr[i]);
            else result.Others.push(allDataArr[i]);
          }
        }
      }
    };

    const setColumns = (resultKeyArr, filterableColumns) => {
      resultKeyArr.forEach((arr) => {
        if (filterableColumns[columnsReference[arr]]) {
          columnObject[arr] = filterableColumns[columnsReference[arr]];
        } else {
          columnObject[arr] = corporateActionsColumns.filter((column) =>
            columnKeysByTranType[columnsReference[arr] || "default"].includes(
              column.label,
            ),
          );
        }
        if (isRecent) {
          const arr1 = [...columnObject[arr]].concat(pdfExtraColumn);
          columnObject[arr] = [...arr1];
        }
      });
    };

    let allDataArr = [];
    if (isRecent) {
      allDataArr = ReportsStore.transectionCorporateTableData.length
        ? [...ReportsStore.transectionCorporateTableData]
        : [];
    } else {
      allDataArr = ReportsStore.upcomingtransectionCorporateTableData.length
        ? [...ReportsStore.upcomingtransectionCorporateTableData]
        : [];
    }

    setResult(tranType, allDataArr);
    const resultKeyArr = Object.keys(result);
    const columns = isRecent ? filterableColumns : filterableColumnsUpcoming;
    setColumns(resultKeyArr, columns);

    if (resultKeyArr.length) {
    }
    //&& Object.keys(result).length > 1 ? true : false;

    return isRecent
      ? isAll
        ? {
            isAll,
            data: result,
            allColumns: columnObject,
          }
        : {
            isAll: false,
            data: getTransectionCorporateTableData(),
          }
      : isAll
        ? {
            isAll,
            data: result,
            allColumns: columnObject,
          }
        : {
            data: getUpcomingTransectionCorporateTableData(),
            isAll: false,
          };

    // return isAll
    //   ? {
    //       data:
    //         (isRecent ? result : getUpcomingTransectionCorporateTableData()) ||
    //         [],
    //       isAll,
    //     }
    //   : {
    //       data:
    //         (isRecent
    //           ? getTransectionCorporateTableData()
    //           : getUpcomingTransectionCorporateTableData()) || [],
    //       isAll,
    //     };

    // return {
    //     data:
    //   (ReportsStore.selectedTabForTransactionCorporate ===
    //   "recent_transaction_corporate"
    //     ?  getTransectionCorporateTableData()
    //     : getUpcomingTransectionCorporateTableData()) || [],
    // }
  };

  const getUpcomingTransectionCorporateTableData = () => {
    return upcomingtransectionCorporateTableData?.filter((eachTransaction) => {
      return selectedSuggetion
        ? eachTransaction?.security_name === selectedSuggetion?.title
        : true;
    });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    if (searchSuggetions?.length) setSearchSuggetionOpen(true);
    else setSearchSuggetionOpen(false);
    if (!e.target.value) {
      setSelectedSuggetion(null);
    }
  };

  const handleTimePeriodReset = () => {
    setFromDate(initialFromDate);
    setToDate(initialToDate);
  };

  const isInfinity = UserStore.infinityData?.actual_value;

  const navigateToInfinity = () => {
    ReportsStore.updateTableDataLoader(true);
    ReportsStore.updateRememberedTransactionCorporateReportData([]);
    ReportsStore.updateTransactionCorporateReportData([]);
    navigate("/reports/infinity-transactions-corporate-action-report");
  };

  const getTransectionCorporateTableDataFORPDF = () => {
    return ReportsStore.rememberedtransectionCorporateTableData;
  };

  const handleSortForTransactionForUpcoming = (filterType) => {
    setFilteredColumnForUpcoming(filterType);
    setIsAscendingForHeaderForUpcoming(!isAscendingForHeaderForUpcoming);
  };

  const sortRecentData = (rowData) => {
    if (rowData) {
      const name = {
        security_name: true,
        account_name: true,
      };
      if (name[filteredColumn] && !isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (name[filteredColumn] && isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "type" && !isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
          ),
        );
      }
      if (filteredColumn === "type" && isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumn].localeCompare(a?.[filteredColumn]),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "quantity" && isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]).toFixed(2) -
              Number(b?.[filteredColumn]).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "quantity" && !isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]).toFixed(2) -
                Number(b?.[filteredColumn]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        (filteredColumn === "rate" ||
          filteredColumn === "divPerShare" ||
          filteredColumn === "ratio" ||
          filteredColumn === "issuePrice") &&
        isAscendingForHeader
      ) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]).toFixed(2) -
              Number(b?.[filteredColumn]).toFixed(2),
          ),
        );
      }
      if (
        (filteredColumn === "rate" ||
          filteredColumn === "divPerShare" ||
          filteredColumn === "ratio" ||
          filteredColumn === "issuePrice") &&
        !isAscendingForHeader
      ) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]).toFixed(2) -
                Number(b?.[filteredColumn]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "amount" && isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumn]?.actual_value).toFixed(2),
          ),
        );
      }
      if (filteredColumn === "amount" && !isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
                Number(b?.[filteredColumn]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (filteredColumn === "transaction_date" && isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "transaction_date" && !isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (filteredColumn === "expiry_date" && isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (filteredColumn === "expiry_date" && !isAscendingForHeader) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (
        (filteredColumn === "exDate" ||
          filteredColumn === "issueEndDate" ||
          filteredColumn === "issueStartDate" ||
          filteredColumn === "recordDate") &&
        isAscendingForHeader
      ) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumn]?.split("-")?.join();
            let bb = b?.[filteredColumn]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        (filteredColumn === "exDate" ||
          filteredColumn === "issueEndDate" ||
          filteredColumn === "issueStartDate" ||
          filteredColumn === "recordDate") &&
        !isAscendingForHeader
      ) {
        ReportsStore.updateTransactionCorporateReportData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumn]?.split("-")?.join();
              let bb = b?.[filteredColumn]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      // if (filteredColumn === "amount" && isAscendingForHeader) {
      //   ReportsStore.updateTransactionCorporateReportData(
      //     [...rowData]?.sort(
      //       (a, b) =>
      //         Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
      //         Number(b?.[filteredColumn]?.actual_value).toFixed(2)
      //     )
      //   );
      // }
      // if (filteredColumn === "amount" && !isAscendingForHeader) {
      //   ReportsStore.updateTransactionCorporateReportData(
      //     [...rowData]
      //       ?.sort(
      //         (a, b) =>
      //           Number(a?.[filteredColumn]?.actual_value).toFixed(2) -
      //           Number(b?.[filteredColumn]?.actual_value).toFixed(2)
      //       )
      //       .reverse()
      //   );
      // }
    }
  };

  const sortUpcomingData = (rowData) => {
    if (rowData) {
      if (
        filteredColumnForUpcoming === "security_name" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumnForUpcoming].localeCompare(
              a?.[filteredColumnForUpcoming],
            ),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "security_name" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumnForUpcoming].localeCompare(
                a?.[filteredColumnForUpcoming],
              ),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "type" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort((a, b) =>
            b?.[filteredColumnForUpcoming].localeCompare(
              a?.[filteredColumnForUpcoming],
            ),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "type" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort((a, b) =>
              b?.[filteredColumnForUpcoming].localeCompare(
                a?.[filteredColumnForUpcoming],
              ),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "frequency" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "frequency" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "rate" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "rate" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        (filteredColumnForUpcoming === "quantity" ||
          filteredColumnForUpcoming === "issuePrice") &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        (filteredColumnForUpcoming === "quantity" ||
          filteredColumnForUpcoming === "issuePrice") &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "divPerShare" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "divPerShare" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "drawcount" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "drawcount" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]).toFixed(2) -
                Number(b?.[filteredColumnForUpcoming]).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "amount" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort(
            (a, b) =>
              Number(a?.[filteredColumnForUpcoming]?.actual_value).toFixed(2) -
              Number(b?.[filteredColumnForUpcoming]?.actual_value).toFixed(2),
          ),
        );
      }
      if (
        filteredColumnForUpcoming === "amount" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort(
              (a, b) =>
                Number(a?.[filteredColumnForUpcoming]?.actual_value).toFixed(
                  2,
                ) -
                Number(b?.[filteredColumnForUpcoming]?.actual_value).toFixed(2),
            )
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "lastpaymentdate" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
            let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        filteredColumnForUpcoming === "lastpaymentdate" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
              let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (
        (filteredColumnForUpcoming === "exDate" ||
          filteredColumnForUpcoming === "date" ||
          filteredColumnForUpcoming === "issueStartDate" ||
          filteredColumnForUpcoming === "issueEndDate") &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
            let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        (filteredColumnForUpcoming === "exDate" ||
          filteredColumnForUpcoming === "date" ||
          filteredColumnForUpcoming === "issueStartDate" ||
          filteredColumnForUpcoming === "issueEndDate") &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
              let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }

      if (
        filteredColumnForUpcoming === "recordDate" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
            let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        filteredColumnForUpcoming === "recordDate" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
              let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
      if (
        filteredColumnForUpcoming === "expiry_date" &&
        isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]?.sort((a, b) => {
            let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
            let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
            return aa < bb ? -1 : aa > bb ? 1 : 0;
          }),
        );
      }
      if (
        filteredColumnForUpcoming === "expiry_date" &&
        !isAscendingForHeaderForUpcoming
      ) {
        ReportsStore.updateUpcomingtransectionCorporateTableData(
          [...rowData]
            ?.sort((a, b) => {
              let aa = a?.[filteredColumnForUpcoming]?.split("-")?.join();
              let bb = b?.[filteredColumnForUpcoming]?.split("-")?.join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            })
            .reverse(),
        );
      }
    }
  };

  useEffect(() => {
    // let rowData = vertualRows;
    let rowData = ReportsStore.transectionCorporateTableData;
    sortRecentData(rowData);
    // eslint-disable-next-line
  }, [filteredColumn, isAscendingForHeader]);

  useEffect(() => {
    let rowData = ReportsStore.rememberedupcomingtransectionCorporateTableData;
    sortUpcomingData(rowData);
  }, [filteredColumnForUpcoming, isAscendingForHeaderForUpcoming]);

  useEffect(() => {
    AuthStore.updateLoadingFullScreen(true);
    if (getAsOfDate(UserStore.asOfDate)) {
      setCookie("asOfDate", getAsOfDate(UserStore.asOfDate));
    }

    return () => {
      setTimeout(() => {
        ReportsStore.updateAllAccountToDefault();
      }, 10);
    };
  }, []);

  // const getInitialfileName = () => {
  //   if (UserStore?.selectedClientId !== "0") {
  //     return UserStore?.userData?.family_name;
  //   } else {
  //     return UserStore?.userData?.full_name;
  //   }
  // };

  useEffect(() => {
    return () => {
      setTimeout(() => {
        ReportsStore.updateRememberedTransactionCorporateReportData([]);
        ReportsStore.updateTransactionCorporateReportData([]);
      }, 10);
    };
  }, []);

  return (
    <Observer>
      {() => (
        <div>
          <PageTitle title={"Corporate Actions Report"} />
          {loading ||
          AuthStore.isLoadingFullScreen ||
          ReportsStore.allAssetClassesAPIcallstate === "pending" ||
          ReportsStore.allMembersAPIcallstate === "pending" ||
          !ReportsStore.inceptionDate ||
          !getAsOfDate(UserStore.asOfDate) ? (
            <LoadingScreen />
          ) : (
            <>
              <Header type="reports" />
              <div className="reports_outer_main">
                <div className="transection_header_container">
                  <PageHeading
                    headingClass="head"
                    headingText="Corporate Actions"
                  />
                  <div className="search_extractdata_wrapper">
                    {isInfinity && (
                      <div
                        className="view_infinity_holdings_btn"
                        onClick={navigateToInfinity}
                      >
                        <button className="darkBlueTextColor darkBlueBorderColor">
                          View Infinity Corporate Actions
                        </button>
                      </div>
                    )}
                    <PopupMenu
                      MenuContent={SearchMenuContent}
                      open={searchSuggetionOpen}
                      setOpen={(flag) => {
                        setSearchSuggetionOpen(flag);
                        //setNiftyMenu(false);
                      }}
                      position={{ top: "50px", left: "0px" }}
                      showArrow={false}
                    >
                      <div className="search_input_container">
                        <img
                          className="search_icon"
                          src={search_svg}
                          alt="search"
                        />
                        <input
                          type="text"
                          id="search-box"
                          autoComplete="off"
                          className="search_input"
                          value={search}
                          placeholder="Search"
                          onKeyDown={handleKeyPress}
                          onChange={handleSearchChange}
                        />

                        <button
                          className="close_icon clickable"
                          onClick={() => setSearch("")}
                          aria-label="Clear Search"
                        >
                          <img src={closeInput} />
                        </button>
                      </div>
                    </PopupMenu>
                    {/* <div
                      ref={exportTransacRef}
                      // onClick={() =>
                      //   !niftyMenu ? setNiftyMenu(true) : setNiftyMenu(false)
                      // }
                    >
                      <PopupMenu
                        position={{ top: "59px", right: "2px" }}
                        setOpen={(flag) => {
                          setNiftyMenu(flag);
                        }}
                        open={niftyMenu}
                        MenuContent={ExtractDataContent}
                      >
                        <div className="export_data_btn">
                          <p className="export_data_text">Export Data</p>
                          <div className="export_text_wrapper">
                            <p className="export_type">Excel</p>
                            <DownArrow />
                          </div>
                        </div>{" "}
                      </PopupMenu>
                    </div> */}
                    <div className="reports-export-wrapper">
                      <ExportReportList
                        exportExcel={() => {
                          exportExcel({
                            isFamilyOnly: true,
                            dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
                            sheetname: "Corporate Actions",
                            // customNameWithTime: getExcelPdfName2(
                            //   "",
                            //   UserStore.transectionCorporateActionReportFilter.selectedMember
                            // ),
                            columns: ExcelPdfClm({ isPdf: false }),

                            reportDetails: {
                              relatioshipManager:
                                UserStore?.exportDetails?.find(
                                  (item) => item.role === "RM",
                                )?.name,
                              serviceManager: UserStore?.exportDetails?.find(
                                (item) => item.role === "CXO",
                              )?.name,
                              date: getPrintDate(
                                getAsOfDate(UserStore.asOfDate),
                              ),
                              clientName:
                                // UserStore.getData === "fam"
                                //   ?
                                UserStore.userData?.family_name,
                              //   : UserStore.userData?.full_name,
                            },
                            excelName: `${getExcelPdfName2(
                              "Corporate Actions Report -",
                              UserStore.transectionCorporateActionReportFilter
                                .selectedMember,
                            )} - ${getCurrentDate()}`,
                            ...getData(),
                          });
                        }}
                        exportPdf={async () => {
                          // printDocument(recentTransactionCorporateId, {
                          //   width: 850,
                          //   height: 850,
                          //   name: `${getExcelPdfName2(
                          //     "Corporate Actions Report -",
                          //     UserStore.transectionCorporateActionReportFilter.selectedMember
                          //   )}`,
                          // });

                          if (isDownloading) return; // guard against double-click while already running
                          setIsDownloading(true);
                          try {
                            await downloadPDFFile({
                              headerName: "Corporate Actions",
                              fileId: recentTransactionCorporateId,
                              isFamilyOnly: true,
                              dateRange: `${getDateString(fromDate)} To ${getDateString(toDate)}`,
                              familyOrClientName:
                                UserStore.userData?.family_name,
                              name: `${getExcelPdfName2(
                                "Corporate Actions Report -",
                                UserStore.transectionCorporateActionReportFilter
                                  .selectedMember,
                              )}`,
                              columns: ExcelPdfClm({ isPdf: true }),
                              data:
                                (ReportsStore.selectedTabForTransactionCorporate ===
                                "recent_transaction_corporate"
                                  ? getTransectionCorporateTableDataFORPDF()
                                  : getUpcomingTransectionCorporateTableData()) ||
                                [],
                            });
                          } finally {
                            setIsDownloading(false);
                            //setNiftyMenu(false);
                          }
                        }}
                        buttonProps={{
                          buttonType: "reportExport",
                        }}
                        popupClassName={{
                          open: "clicked-hover",
                          close: "",
                          wrapperClass: "popup_menu_container",
                          containerClass: "downloadPdf",
                        }}
                        restrictHover={true}
                        itemRefs={exportItemRefs}
                        menuItems={exportDataMenu}
                        accessibilityValues={{
                          buttonId: "export-dropdown",
                          ariaHaspopup: "menu",
                          ariaControls: "extract-menu",
                          ariaLabel: "Extract Data",
                        }}
                      >
                        <>
                          {isDownloading && (
                            <div className="popup_downloader">
                              <img src={loaderGIF} alt="img" />
                            </div>
                          )}
                        </>
                      </ExportReportList>
                    </div>
                  </div>
                </div>
                <div className="reports_yellow_container">
                  <div className="transecitons_yellow_wrapper corporate_action">
                    <div className="transections_first_container">
                      <div
                        className={`time_period_container ${
                          ReportsStore.selectedTabForTransactionCorporate ===
                          "upcoming_transactions_corporate"
                            ? "disabled_time_period"
                            : ""
                        }`}
                      >
                        <RadioGroup
                          heading="Time Period"
                          name="time_period"
                          radioBtnArray={timePeriodRadioBtnsData}
                          handleChange={handleTimePeriodChange}
                          value={timePeriod}
                          radioBtnsPerRow={4}
                          containerClass="all_radio_btns corporate_grid1"
                          groupId={"corporate-action-time-period"}
                          groupName={"corporate-action-radio-group1"}
                          isDisabled={
                            ReportsStore.selectedTabForTransactionCorporate ===
                            "upcoming_transactions_corporate"
                          }
                        />
                        <DatePicker2
                          timePeriod={timePeriod}
                          fromDate={fromDate}
                          toDate={toDate}
                          setFromDate={setFromDate}
                          setToDate={setToDate}
                          resetedFromDate={resetedFromDate}
                          resetedToDate={resetedToDate}
                          initialFromDate={initialFromDate}
                          initialToDate={initialToDate}
                          handleReset={handleTimePeriodReset}
                          // isActive={timePeriod === "custom"}
                          isActive={
                            ReportsStore.selectedTabForTransactionCorporate !==
                            "upcoming_transactions_corporate"
                          }
                          open={datePickerModalOpen}
                          setOpen={() => {
                            handleTimePeriodChange("custom");
                            setDatePickerModalOpen(true);
                          }}
                          onClose={() => setDatePickerModalOpen(false)}
                        />
                      </div>
                    </div>
                    <div className="transections_second_container">
                      <RadioGroup
                        heading="Transaction Type"
                        name="transaction_type"
                        radioBtnArray={CorporateTranTypeRadioBtnsData}
                        handleChange={handleTranTypeChange}
                        value={tranType}
                        radioBtnsPerRow={5}
                        containerClass="all_radio_btns corp_action_grid"
                        groupId={"corporate-action-transaction-type"}
                        groupName={"corporate-action-radio-group2"}
                      />
                      <div className="dropdown_container transaction_corporate_dropdown">
                        <AssetClassesCheckBox
                          heading={getHeadingForAssetClass(selectedAssetClass)}
                          position={{
                            top: "56px",
                            left: "0px",
                            zIndex: "20",
                            padding: "3px",
                            overflowY: "hidden",
                            border: "1px solid #e3e3e3",
                          }}
                          showArrow={false}
                          headingValue={selectedAssetClass}
                          allData={ReportsStore.allAssetClassesData}
                          setHeadingValue={(changedAssetClass) => {
                            if (changedAssetClass === "All") {
                              if (
                                selectedAssetClass === "All" ||
                                ReportsStore.allAssetClassesData
                                  ?.map((assetClass) =>
                                    selectedAssetClass?.includes(assetClass.id),
                                  )
                                  ?.every(Boolean)
                              ) {
                                setSelectedAssetClass([]);
                              } else {
                                setSelectedAssetClass(
                                  ReportsStore.allAssetClassesData?.map(
                                    (assetClass) => {
                                      return assetClass?.id;
                                    },
                                  ),
                                );
                              }
                            } else {
                              if (selectedAssetClass === "All") {
                                setSelectedAssetClass(
                                  ReportsStore.allAssetClassesData
                                    ?.map((assetClass) => {
                                      return assetClass?.id;
                                    })
                                    .filter(
                                      (assetClassId) =>
                                        assetClassId !== changedAssetClass,
                                    ),
                                );
                              } else {
                                if (
                                  selectedAssetClass?.includes(
                                    changedAssetClass,
                                  )
                                ) {
                                  setSelectedAssetClass((prevState) => {
                                    return prevState.filter(
                                      (eachAssetClass) =>
                                        eachAssetClass !== changedAssetClass,
                                    );
                                  });
                                } else {
                                  setSelectedAssetClass([
                                    ...selectedAssetClass,
                                    changedAssetClass,
                                  ]);
                                }
                              }
                            }
                          }}
                          //showPopup={true}
                          showArrow={false}
                          // disabledPopup={
                          //   ReportsStore.usersAccounts.length === 1
                          // }
                          //isDisabled={false}
                          popupClassName={{
                            wrapperClass:
                              "popup_menu_container dropdown-wrapper",
                            dropDownContainerClass: "all_accounts_dropdown",
                            popupMenuClass: "",
                          }}
                          restrictHover={true}
                          OPTIONS={[
                            {
                              id: "All",
                              name: "All Asset Classes",
                            },
                          ].concat(ReportsStore.allAssetClassesData)}
                          accessibilityValues={{
                            buttonId: "",
                            ariaHaspopup: "listbox",
                            ariaControls: "asset-listbox",
                            ariaLabel: "Asset Class Filters",
                          }}
                        />
                        <GoldenDropDown
                          isDisabled={
                            ReportsStore.selectedTabForTransactionCorporate !==
                            "recent_transaction_corporate"
                          }
                          heading={
                            getHeadingForMembers(selectedMember)
                            // ReportsStore.selectedTabForTransactionCorporate ===
                            //   "recent_transaction_corporate"
                            //   ? getHeadingForMembers(selectedMember)
                            //   : getDecodedToken()?.user_type === "manager" ||
                            //     (getDecodedToken()?.user_type === "employee" &&
                            //       UserStore?.selectedClientId !== "0") ||
                            //     (getDecodedToken()?.user_type === "customer" &&
                            //       getDecodedToken()?.primary === "false") ||
                            //     UserStore?.selectedClientId !== "0"
                            //     ? getHeadingForMembers(selectedMember)
                            //     : "All Members"
                          }
                          selectedMember={selectedMember}
                          showPopup={
                            getDecodedToken()?.user_type === "manager" ||
                            (getDecodedToken()?.user_type === "employee" &&
                              UserStore?.selectedClientId !== "0") ||
                            (getDecodedToken()?.user_type === "customer" &&
                              getDecodedToken()?.primary === "false") ||
                            UserStore?.selectedClientId !== "0"
                              ? false
                              : true
                          }
                          popupMenuClass="reports_select_family_member_popup_menu"
                          ReportMenuContent={AllMembersMenuContent}
                          reportsMenuOpen={allMembersMenuOpen}
                          setReportsMenuOpen={setAllMembersMenuOpen}
                          position={{
                            top: "57px",
                            right: "20px",
                            minWidth: "380px",
                          }}
                          showArrow={false}
                          dropDownContainerClass="all_members_dropdown"
                        />
                      </div>
                    </div>
                  </div>
                  <ApplyFilter
                    customCss="reusable-button"
                    onApplyFilter={onApplyFilter}
                    onClearFilter={onClearFilter}
                  />
                </div>{" "}
                {ReportsStore.tableDataLoader ? (
                  <div className="report_table_loader">
                    <div className="report_loader_wrapper">
                      <img
                        className="loading_gif"
                        src={loaderGIF}
                        alt="loading..."
                      />
                    </div>
                  </div>
                ) : (
                  <div className="transaction_container extra-padding-30">
                    <Tabs
                      onSelect={(value) => {
                        ReportsStore.updateTransectionCorporateReportTab(value);
                      }}
                      renderCondition={true}
                      selectedTab={
                        ReportsStore.selectedTabForTransactionCorporate
                      }
                      tabs={[
                        {
                          label: "Recent Corporate Actions",
                          value: "recent_transaction_corporate",
                        },
                        {
                          label: "Upcoming Corporate Actions",
                          value: "upcoming_transactions_corporate",
                        },
                      ]}
                    />
                    <div className="transactions_corporate_report transaction_table_container">
                      {ReportsStore.selectedTabForTransactionCorporate ===
                        "recent_transaction_corporate" && (
                        <>
                          {ReportsStore?.transectionCorporateTableData
                            ?.length && !ReportsStore.tableDataLoader ? (
                            <Table
                              data={getTransectionCorporateTableData()}
                              columns={getDynamicColumns({
                                allColumns: corporateActionsColumns,
                                isNonFilterable: false,
                                isSameUI: true,
                              })}
                              tableClass={`custom_table3 ${getTableClass()} reports-table`}
                              handleSort={handleSortForTransaction}
                              sortKey={filteredColumn}
                              isAscending={isAscendingForHeader}
                            />
                          ) : (
                            <div className="empty_state_for_valuation">
                              <EmptyDerivatives
                                image={emptyIcon}
                                message="You do not have any records to display"
                              />
                            </div>
                          )}
                        </>
                      )}
                      {ReportsStore.selectedTabForTransactionCorporate ===
                        "upcoming_transactions_corporate" &&
                        !ReportsStore.tableDataLoader && (
                          <>
                            {upcomingtransectionCorporateTableData?.length &&
                            getUpcomingTransectionCorporateTableData()
                              .length ? (
                              <Table
                                data={getUpcomingTransectionCorporateTableData()}
                                columns={getUpcomingColumns(
                                  corporateActionsColumns,
                                  true,
                                )}
                                tableClass={`custom_table3 ${getUpcomingClass()} reports-table`}
                                handleSort={handleSortForTransactionForUpcoming}
                                sortKey={filteredColumnForUpcoming}
                                isAscending={isAscendingForHeaderForUpcoming}
                              />
                            ) : (
                              <div className="empty_state_for_valuation">
                                <EmptyDerivatives
                                  image={emptyIcon}
                                  message="You do not have any records to display"
                                />
                              </div>
                            )}
                          </>
                        )}
                    </div>
                  </div>
                )}
              </div>{" "}
              {/* <PdfTable
                isFamilyOnly={true}
                dateRange={`${getDateString(fromDate)} To ${getDateString(
                  toDate,
                )}`}
                headerName={"Corporate Actions"}
                familyOrClientName={
                  UserStore.userData?.family_name
                  //   getExcelPdfName2(
                  //   "",
                  //   UserStore.transectionCorporateActionReportFilter
                  //     .selectedMember
                  // )
                }
                columns={ExcelPdfClm({ isPdf: true })}
                data={
                  (ReportsStore.selectedTabForTransactionCorporate ===
                  "recent_transaction_corporate"
                    ? getTransectionCorporateTableDataFORPDF()
                    : getUpcomingTransectionCorporateTableData()) || []
                }
                id={recentTransactionCorporateId}
              /> */}
            </>
          )}
        </div>
      )}
    </Observer>
  );
});

export default TransactionsCorporateActionReport;
